// @ts-nocheck
import * as anchor from '@anchor-lang/core';
import axios from 'axios';
import { BN, web3 } from '@anchor-lang/core';
import { walletAdapterIdentity } from '@metaplex-foundation/umi-signer-wallet-adapters';
import { createAssociatedTokenAccount, createAssociatedTokenAccountInstruction, createCloseAccountInstruction, createMint, createSyncNativeInstruction, getAssociatedTokenAddressSync, mintTo, } from '@solana/spl-token';
import { findMasterEditionPda, findMetadataPda, mplTokenMetadata, fetchAllDigitalAssetWithTokenByOwner, fetchDigitalAsset, } from '@metaplex-foundation/mpl-token-metadata';
import { createUmi } from '@metaplex-foundation/umi-bundle-defaults';
import { publicKey } from '@metaplex-foundation/umi';
import { WebUploader } from '@irys/web-upload';
import { WebSolana } from '@irys/web-upload-solana';
import { TOKEN_PROGRAM_ID } from '@solana/spl-token';
import { ItemFilter } from '../../types';
import { CATEGORIES, NFT_NAME, NFT_SYMBOL } from '../../constants';
import idl from './crypto_verse_ai.json';
import { decodePriceUpdateV2 } from './pyth-price-update-v2';
let irysUploader = null;
let isDevnet = false;
let createUris = null;
export const configureNftUriCreator = (fn) => {
    createUris = fn;
};
let program = null;
let wallet = null;
let sendTransaction = null;
let connection = null;
let umi = null;
let onAccountChangeCallback = null;
const TX_CONFIRM_OPTION = {
    commitment: 'processed',
};
export const Consts = {};
export const SOL_PRICE_FEED_ACCOUNT = '7UVimffxr9ow1uXYxsr4LHAcV58mLzhmwaeKvJ1pjLiE';
export const CAI_SOL_POOL = 'AaXUi94d1SggniUtDBiVyzcb6hUX57bJRyXRwUKhhp8h';
export const SOL_ACCOUNT_RAY_POOL = 'FBpta6BdCe4ukUKMTPsewpetYHXsvE1d4aQ8151ptv1A';
export const CAI_ACCOUNT_RAY_POOL = 'AWHucB1y1zrUYiYtEU2pQZnBbEEa51ahB9LNFEioJpNb';
export const CAI_MINT = 'G9BSthNRbyoQpcj2rkGEamrmdmgZNvD6Mn7yc7HmQGc8';
export const WSOL_MINT = 'So11111111111111111111111111111111111111112';
export const CAI_DECIMALS = 0;
const MAX_COMPUE_BUDGET_IX = web3.ComputeBudgetProgram.setComputeUnitLimit({ units: 1400000 });
const categoriesFromMetadata = (metadata) => {
    const attrs = Array.isArray(metadata?.attributes) ? metadata.attributes : [];
    const fromAttrs = attrs
        .filter((a) => a?.trait_type === 'Category')
        .map((a) => (typeof a?.value === 'string' ? a.value.trim() : ''))
        .filter(Boolean);
    const fromList = Array.isArray(metadata?.categories)
        ? metadata.categories.filter((c) => typeof c === 'string' && Boolean(c.trim()))
        : [];
    const list = fromList.length
        ? fromList
        : fromAttrs.length
            ? fromAttrs
            : metadata?.category
                ? [metadata.category]
                : [CATEGORIES[0]];
    return [...new Set(list.map((c) => c.trim()).filter(Boolean))];
};
const normalizeSolNFT = (nft) => {
    const categories = categoriesFromMetadata(nft.metadata);
    return {
        ...nft,
        image: nft.metadata.image,
        name: nft.metadata.name,
        description: nft.metadata.description,
        originPrice: nft.metadata.price,
        price: `${nft.metadata.price}`,
        uri: nft.metadata.uri,
        currency: 'USD',
        categories,
        tokenId: nft.mint.publicKey.toString(),
        owner: nft.escrow?.sellerAuthority.toString() || nft.token.owner.toString(),
        displayKey: `Solana-v1-#${nft.mint.publicKey.toString()}`,
    };
};
export const contractPrice = (price) => {
    return new BN(price * Consts.defaultDenominator);
};
export const getProgram = () => {
    return program;
};
export const isSvmProgramInitialized = () => program != null;
const applyIdlConstants = () => {
    program.idl.constants?.forEach((c) => {
        let value;
        switch (c.type) {
            case 'u64':
                value = new BN(c.value);
                break;
            case 'string':
                value = c.value.slice(1, -1);
                break;
            case 'bytes':
                value = JSON.parse(c.value);
                break;
            default:
        }
        Consts[c.name] = value;
    });
};
const setupIrys = (connection_t, wallet_t) => {
    if (!wallet_t?.publicKey)
        return;
    const rpcEndpoint = connection_t.rpcEndpoint;
    isDevnet = rpcEndpoint.includes('devnet');
    if (typeof window !== 'undefined') {
        const irysBuilder = WebUploader(WebSolana)
            .withProvider(wallet_t)
            .withTokenOptions()
            .withRpc(rpcEndpoint);
        isDevnet ? irysBuilder.devnet() : irysBuilder.mainnet();
        irysBuilder
            .build()
            .then((uploader) => {
            irysUploader = uploader;
        })
            .catch((err) => {
            console.warn('Irys uploader init skipped:', err?.message ?? err);
        });
    }
};
const bootstrapProgram = (connection_t, wallet_t) => {
    wallet = wallet_t;
    connection = connection_t;
    umi = createUmi(connection_t).use(walletAdapterIdentity(wallet_t)).use(mplTokenMetadata());
    setupIrys(connection_t, wallet_t);
    const provider = new anchor.AnchorProvider(connection_t, wallet_t, anchor.AnchorProvider.defaultOptions());
    program = new anchor.Program(idl, provider);
    applyIdlConstants();
};
export const initProgramInstance = (a, b, c) => {
    if (a instanceof web3.Connection) {
        const connection_t = a;
        const wallet_t = b;
        if (wallet &&
            connection &&
            wallet.publicKey?.equals(wallet_t.publicKey) &&
            connection.rpcEndpoint === connection_t.rpcEndpoint) {
            return;
        }
        bootstrapProgram(connection_t, wallet_t);
        return;
    }
    const wallet_t = a;
    const rpc = b;
    if (wallet && wallet.publicKey?.equals(wallet_t.publicKey))
        return;
    connection = new web3.Connection(rpc);
    wallet = wallet_t;
    onAccountChangeCallback = c ?? null;
    bootstrapProgram(connection, wallet_t);
    if (wallet.publicKey && onAccountChangeCallback) {
        connection.onAccountChange(wallet.publicKey, onAccountChangeCallback);
    }
};
export const setWallet = (wallet_t) => {
    wallet = wallet_t;
    if (!umi) {
        if (connection) {
            bootstrapProgram(connection, wallet_t);
        }
        return;
    }
    umi = umi.use(walletAdapterIdentity(wallet));
    if (wallet.publicKey) {
        connection.onAccountChange(wallet.publicKey, onAccountChangeCallback);
        setupIrys(connection, wallet);
    }
    const provider = new anchor.AnchorProvider(connection, wallet, anchor.AnchorProvider.defaultOptions());
    program = new anchor.Program(idl, provider);
};
export const getBlockHeight = async (rpc) => {
    const response = await axios.post(rpc, {
        jsonrpc: '2.0',
        id: 1,
        method: 'getBlockHeight',
        params: [],
    });
    return response.data.result;
};
export const getSolBalance = async (address) => {
    return await connection.getBalance(address);
};
export const getTokenBalance = async (owner, mint) => {
    const ata = getATA(new web3.PublicKey(mint), owner);
    return await connection.getTokenAccountBalance(ata);
};
export const getTransactionStatus = async (hash) => {
    const status = await connection.getSignatureStatus(hash);
    if (!status)
        return 'Not Found';
    if (status.err)
        return 'Failed';
    if (status.confirmationStatus === 'processed')
        return 'Pending';
    if (status.confirmationStatus === 'confirmed')
        return 'Confirmed';
    if (status.confirmationStatus === 'finalized')
        return 'Success';
};
export const updateWallet = (wallet_t) => {
    if (!connection)
        return;
    bootstrapProgram(connection, wallet_t);
};
export function getPDA(seeds, pID) {
    return web3.PublicKey.findProgramAddressSync(seeds, new web3.PublicKey(pID));
}
export function getGlobalStateKey() {
    return getPDA([Buffer.from(Consts.globalStateSeed)], program.programId)[0];
}
export function getEscrowKey(mint) {
    return getPDA([Buffer.from(Consts.escrowSeed), mint.toBuffer()], program.programId)[0];
}
export async function fetchEscrow(mint) {
    const escrowKey = getPDA([Buffer.from(Consts.escrowSeed), mint.toBuffer()], program.programId)[0];
    const escrow = await program.account.escrow.fetch(escrowKey);
    return escrow;
}
export async function isNFTListed(mint) {
    const escrowKey = getPDA([Buffer.from(Consts.escrowSeed), mint.toBuffer()], program.programId)[0];
    const escrow = await program.account.escrow.fetch(escrowKey);
    return escrow.isSold.toNumber() == 0;
}
export async function fetchGlobalState() {
    const globalStateKey = getGlobalStateKey();
    const globalState = await program.account.globalState.fetchNullable(globalStateKey);
    return globalState;
}
export async function getAccountBalance(pubKey) {
    return (await connection.getAccountInfo(pubKey)).lamports;
}
export const requestAirdrop = async (address) => {
    const airdropSignature = await connection.requestAirdrop(address, 1e10); // 1 SOL = 1e9 lamports
    await connection.confirmTransaction(airdropSignature, 'confirmed');
};
export const getATA = (mint, owner) => {
    return getAssociatedTokenAddressSync(new web3.PublicKey(mint), new web3.PublicKey(owner));
};
export const getOrCreateATA = async (mint, owner) => {
    const ata = getAssociatedTokenAddressSync(mint, owner);
    const accountInfo = await connection.getAccountInfo(ata);
    if (accountInfo) {
        return [];
    }
    return [createAssociatedTokenAccountInstruction(wallet.publicKey, ata, owner, mint)];
};
export const getOrCreateWSOLATA = async (mint, owner, lamports) => {
    const wSolATA = getAssociatedTokenAddressSync(mint, owner);
    const ix = await getOrCreateATA(mint, owner);
    ix.push(web3.SystemProgram.transfer({
        fromPubkey: owner,
        toPubkey: wSolATA,
        lamports: lamports,
    }), createSyncNativeInstruction(wSolATA, TOKEN_PROGRAM_ID));
    return ix;
};
export const getPayAmount = async (isWSOL, nftPrice) => {
    const globalState = await fetchGlobalState();
    const solPriceFeedAccount = await program.provider.connection.getAccountInfo(globalState.solPriceFeed);
    const solPriceInfo = decodePriceUpdateV2(solPriceFeedAccount.data);
    const solPrice = solPriceInfo.priceMessage.exponent < 0
        ? solPriceInfo.priceMessage.price.toNumber() /
            new BN(10).pow(new BN(-solPriceInfo.priceMessage.exponent)).toNumber()
        : solPriceInfo.priceMessage.price
            .mul(new BN(10).pow(new BN(solPriceInfo.priceMessage.exponent)))
            .toNumber();
    console.log('Sol Price', solPrice);
    let tokenPrice = solPrice;
    if (!isWSOL) {
        const solRealAmount = (await program.provider.connection.getTokenAccountBalance(globalState.solAccountRay)).value.uiAmount;
        const caiRealAmount = (await program.provider.connection.getTokenAccountBalance(globalState.caiAccountRay)).value.uiAmount;
        tokenPrice = (solRealAmount * solPrice) / caiRealAmount;
        console.log('Cai Price', tokenPrice);
    }
    return Math.ceil((nftPrice.toNumber() * Math.pow(10, isWSOL ? 9 : globalState.caiDecimals)) /
        tokenPrice /
        Consts.defaultDenominator);
};
export const simulateMint = async (decimals) => {
    let mintKeypair = web3.Keypair.generate();
    let mintKey = mintKeypair.publicKey;
    let payer = wallet.payer;
    await createMint(program.provider.connection, payer, wallet.publicKey, wallet.publicKey, decimals, mintKeypair);
    const tokenATA = getAssociatedTokenAddressSync(mintKey, wallet.publicKey, true);
    await createAssociatedTokenAccount(program.provider.connection, payer, mintKey, wallet.publicKey);
    await mintTo(program.provider.connection, payer, mintKey, tokenATA, payer, 1000000000);
    return mintKey;
};
export const initializeSC = async (presalePrice, solPriceFeed, solAccountRay, caiAccountRay, caiMint) => {
    return await program.methods
        .initialize(contractPrice(presalePrice))
        .accounts({
        solPriceFeed,
        solAccountRay,
        caiAccountRay,
        caiMint,
        authority: wallet.publicKey,
    })
        .rpc();
};
export const updateAuthority = async (newAuthority) => {
    return await program.methods
        .updateAuthority()
        .accounts({
        newAuthority,
    })
        .rpc();
};
export const updateCaiMint = async (caiMint) => {
    return await program.methods
        .updateCaiMint()
        .accounts({
        caiMint,
    })
        .rpc();
};
export const updateFee = async ({ sell_fee, buy_fee }) => {
    return await program.methods.updateFee(contractPrice(sell_fee), contractPrice(buy_fee)).rpc();
};
export const updatePaused = async (isPaused) => {
    return await program.methods.updatePaused(isPaused ? 1 : 0).rpc();
};
export const updatePriceFeed = async (solPriceFeed, caiMint, caiPriceFeed) => {
    return await program.methods
        .updatePriceFeed()
        .accounts({
        solPriceFeed,
        caiPriceFeed,
        caiMint,
    })
        .rpc();
};
export const updatePresalePrice = async (presalePrice) => {
    return await program.methods.updatePresalePrice(contractPrice(presalePrice)).rpc();
};
const ntobs58 = (x) => anchor.utils.bytes.bs58.encode(new anchor.BN(x).toArrayLike(Buffer, 'le', 8));
const fetchNftUri = async (nft) => {
    let nftData = {};
    try {
        nftData = (await axios.get(nft.metadata.uri)).data;
    }
    catch (e) {
        console.log(e);
    }
    nft.metadata = {
        ...nft.metadata,
        ...nftData,
    };
};
export const getListedNfts = async (cacheOrConnection, ownerOrWallet) => {
    if (cacheOrConnection?.rpcEndpoint) {
        const connection_t = cacheOrConnection;
        const wallet_t = ownerOrWallet;
        if (!program)
            initProgramInstance(connection_t, wallet_t);
        const activeEscrows = await program.account.escrow.all([
            {
                memcmp: {
                    offset: 80,
                    bytes: ntobs58(0),
                },
            },
        ]);
        const listedNfts = [];
        for await (const escrow of activeEscrows) {
            if (escrow.account.sellerAuthority.equals(wallet_t.publicKey)) {
                continue;
            }
            const nft = await fetchDigitalAsset(umi, escrow.account.nftMint);
            if (nft.metadata.uri.length) {
                await fetchNftUri(nft);
                nft.metadata.price = escrow.account.price.toNumber() / Consts.defaultDenominator;
                listedNfts.push(nft);
            }
        }
        return listedNfts;
    }
    const cache = cacheOrConnection;
    const owner = ownerOrWallet;
    const filters = [
        {
            memcmp: {
                offset: 80,
                bytes: ntobs58(0),
            },
        },
    ];
    if (owner) {
        filters.push({
            memcmp: {
                offset: 8,
                bytes: owner.toString(),
            },
        });
    }
    const activeEscrows = await program.account.escrow.all(filters);
    const listedNfts = [];
    for await (const escrow of activeEscrows) {
        const cachedNFT = cache.filter((item) => item.tokenId === escrow.account.nftMint.toString())[0];
        const price = escrow.account.price.toNumber() / Consts.defaultDenominator;
        if (cachedNFT) {
            cachedNFT.price = price;
            listedNfts.push(cachedNFT);
        }
        else {
            const nft = await fetchDigitalAsset(umi, escrow.account.nftMint);
            if (nft.metadata.uri.length) {
                nft.metadata.price = price;
                await fetchNftUri(nft, escrow);
                nft.escrow = escrow.account;
                nft.type = ItemFilter.Listed;
                listedNfts.push(normalizeSolNFT(nft));
            }
        }
    }
    return listedNfts;
};
export const getMyListedNfts = async (cache) => {
    if (wallet?.publicKey) {
        return await getListedNfts(cache, wallet?.publicKey);
    }
    return [];
};
export const getMyNfts = async (cache) => {
    const myNfts = [];
    if (wallet?.publicKey) {
        const globalState = await fetchGlobalState();
        const globalStateKey = getGlobalStateKey();
        const nfts = await fetchAllDigitalAssetWithTokenByOwner(umi, publicKey(wallet.publicKey.toString()));
        for await (const nft of nfts) {
            if (nft.metadata.updateAuthority === globalStateKey.toString()) {
                const cachedNFT = cache.filter((item) => item.tokenId === nft.token.mint.toString())[0];
                const price = globalState.presalePrice.toNumber() / Consts.defaultDenominator;
                if (cachedNFT) {
                    cachedNFT.price = price;
                    myNfts.push(cachedNFT);
                }
                else {
                    nft.metadata.price = price;
                    await fetchNftUri(nft);
                    nft.type = ItemFilter.MyWallet;
                    myNfts.push(normalizeSolNFT(nft));
                }
            }
        }
    }
    return myNfts;
};
export const createAndMintNft = async (nft, tokenMint) => {
    if (!createUris) {
        throw new Error('configureNftUriCreator must be called before createAndMintNft');
    }
    const res = await createUris([nft]);
    return await mintNft(res.data.data[0], tokenMint);
};
export const mintNft = async (uriOrMetadata, tokenMint) => {
    const uri = typeof uriOrMetadata === 'string' ? uriOrMetadata : uriOrMetadata.uri;
    tokenMint = new web3.PublicKey(tokenMint);
    const nftMint = web3.Keypair.generate();
    let metadataAccount = findMetadataPda(umi, {
        mint: publicKey(nftMint.publicKey),
    })[0];
    //derive the master edition pda
    let masterEditionAccount = findMasterEditionPda(umi, {
        mint: publicKey(nftMint.publicKey),
    })[0];
    const isWSOL = tokenMint.toString() == Consts.wsolMint.toString();
    const userAuthority = wallet.publicKey;
    const globalState = await fetchGlobalState();
    console.log('Presale price is $', globalState.presalePrice.toNumber() / Consts.defaultDenominator);
    const amount = await getPayAmount(isWSOL, globalState.presalePrice);
    console.log('Amount To send', amount);
    const preInstructions = isWSOL
        ? await getOrCreateWSOLATA(tokenMint, userAuthority, amount + 1e7)
        : [];
    const postInstructions = isWSOL
        ? [
            await createCloseAccountInstruction(getAssociatedTokenAddressSync(tokenMint, userAuthority, true), userAuthority, userAuthority),
        ]
        : [];
    const userNftAccount = getAssociatedTokenAddressSync(nftMint.publicKey, userAuthority, true);
    const tx = await program.methods
        .mintNft(NFT_NAME, NFT_SYMBOL, uri)
        .accounts({
        userAuthority,
        tokenMint,
        nftMint: nftMint.publicKey,
        userNftAccount,
        metadataAccount,
        masterEditionAccount,
    })
        .signers([nftMint])
        .preInstructions([MAX_COMPUE_BUDGET_IX, ...preInstructions])
        .postInstructions([...postInstructions])
        // .rpc(TX_CONFIRM_OPTION);
        .transaction();
    const txId = await program.provider.sendAndConfirm(tx, [nftMint], TX_CONFIRM_OPTION);
    return { expectedAmount: amount, txId: txId, mintKey: nftMint.publicKey };
};
export const mintMultipleNfts = async (uris, tokenMint) => {
    tokenMint = new web3.PublicKey(tokenMint);
    const isWSOL = tokenMint.toString() == Consts.wsolMint.toString();
    const userAuthority = wallet.publicKey;
    const globalState = await fetchGlobalState();
    const amount = await getPayAmount(isWSOL, globalState.presalePrice);
    console.log('Amount to send', amount * uris.length);
    const preInstructions = isWSOL
        ? await getOrCreateWSOLATA(tokenMint, userAuthority, amount * uris.length + 1e7)
        : [];
    const postInstructions = isWSOL
        ? [
            await createCloseAccountInstruction(getAssociatedTokenAddressSync(tokenMint, userAuthority), userAuthority, userAuthority),
        ]
        : [];
    const tx = new web3.Transaction();
    const signers = [];
    tx.add(MAX_COMPUE_BUDGET_IX);
    isWSOL && tx.add(...preInstructions);
    for await (const uri of uris) {
        const nftMint = web3.Keypair.generate();
        console.log('New NFT Mint', nftMint.publicKey.toString());
        let metadataAccount = findMetadataPda(umi, {
            mint: publicKey(nftMint.publicKey),
        })[0];
        //derive the master edition pda
        let masterEditionAccount = findMasterEditionPda(umi, {
            mint: publicKey(nftMint.publicKey),
        })[0];
        signers.push(nftMint);
        const userNftAccount = getAssociatedTokenAddressSync(nftMint.publicKey, userAuthority);
        tx.add(await program.methods
            .mintNft(NFT_NAME, NFT_SYMBOL, uri)
            .accounts({
            userAuthority,
            tokenMint,
            nftMint: nftMint.publicKey,
            userNftAccount,
            metadataAccount,
            masterEditionAccount,
        })
            .instruction());
    }
    isWSOL && tx.add(...postInstructions);
    return await program.provider.sendAndConfirm(tx, signers);
};
export const withdrawIncome = async () => {
    const globalState = await fetchGlobalState();
    const userAuthority = wallet.publicKey;
    const globalStateKey = getGlobalStateKey();
    const wsolMint = new web3.PublicKey(Consts.wsolMint);
    const postInstructions = [
        createCloseAccountInstruction(getAssociatedTokenAddressSync(wsolMint, userAuthority, true), userAuthority, userAuthority),
    ];
    return await program.methods
        .withdrawToken()
        .accounts({
        tokenMint: wsolMint,
        feeTokenAccount: getAssociatedTokenAddressSync(wsolMint, globalStateKey, true),
        dstTokenAccount: getAssociatedTokenAddressSync(wsolMint, userAuthority, true),
    })
        .postInstructions([
        await program.methods
            .withdrawToken()
            .accounts({
            tokenMint: globalState.caiMint,
            feeTokenAccount: getAssociatedTokenAddressSync(globalState.caiMint, globalStateKey, true),
            dstTokenAccount: getAssociatedTokenAddressSync(globalState.caiMint, userAuthority, true),
        })
            .instruction(),
        ...postInstructions,
    ])
        .rpc();
};
export const sellNft = async (mint, price) => {
    mint = new web3.PublicKey(mint);
    const metadataAccount = findMetadataPda(umi, {
        mint: publicKey(mint),
    })[0];
    const escrow = getEscrowKey(mint);
    const userNftAccount = getAssociatedTokenAddressSync(mint, wallet.publicKey, true);
    const escrowNftAccount = getAssociatedTokenAddressSync(mint, escrow, true);
    const tx = await program.methods
        .sellNft(contractPrice(price))
        .accounts({
        userAuthority: wallet.publicKey,
        nftMint: mint,
        metadataAccount,
        escrow,
        userNftAccount,
        escrowNftAccount,
    })
        .transaction();
    const txId = await program.provider.sendAndConfirm(tx, [], TX_CONFIRM_OPTION);
    return txId;
};
export const sellMultipleNfts = async (nfts) => {
    const tx = new web3.Transaction();
    tx.add(MAX_COMPUE_BUDGET_IX);
    for await (const nft of nfts) {
        // const nft = nfts[i]
        let metadataAccount = findMetadataPda(umi, {
            mint: publicKey(nft.mint),
        })[0];
        tx.add(await program.methods
            .sellNft(contractPrice(nft.price))
            .accounts({
            userAuthority: wallet.publicKey,
            nftMint: nft.mint,
            metadataAccount,
        })
            .instruction());
    }
    return await program.provider.sendAndConfirm(tx);
};
export const cancelNft = async (mint) => {
    mint = new web3.PublicKey(mint);
    const escrow = getEscrowKey(mint);
    const userNftAccount = getAssociatedTokenAddressSync(mint, wallet.publicKey, true);
    const escrowNftAccount = getAssociatedTokenAddressSync(mint, escrow, true);
    const tx = await program.methods
        .cancelNft()
        .accounts({
        userAuthority: wallet.publicKey,
        nftMint: mint,
        escrow,
        userNftAccount,
        escrowNftAccount,
    })
        .transaction();
    const txId = await program.provider.sendAndConfirm(tx, [], TX_CONFIRM_OPTION);
    return txId;
};
export const cancelMultipleNfts = async (nftMints) => {
    const tx = new web3.Transaction();
    tx.add(MAX_COMPUE_BUDGET_IX);
    for await (const nftMint of nftMints) {
        const createIxns = await getOrCreateATA(new web3.PublicKey(nftMint), wallet.publicKey);
        createIxns.length && tx.add(...createIxns);
        tx.add(await program.methods
            .cancelNft()
            .accounts({
            userAuthority: wallet.publicKey,
            nftMint,
        })
            .instruction());
    }
    return await program.provider.sendAndConfirm(tx);
};
export const updateNftPrice = async (mint, price) => {
    mint = new web3.PublicKey(mint);
    const tx = await program.methods
        .updateNftPrice(contractPrice(price))
        .accounts({
        userAuthority: wallet.publicKey,
        nftMint: mint,
        escrow: getEscrowKey(mint),
    })
        .transaction();
    const txId = await program.provider.sendAndConfirm(tx, [], TX_CONFIRM_OPTION);
    return txId;
};
export const updatePriceMultipleNfts = async (nfts) => {
    const tx = new web3.Transaction();
    tx.add(MAX_COMPUE_BUDGET_IX);
    for await (const nft of nfts) {
        // const nft = nfts[i]
        let metadataAccount = findMetadataPda(umi, {
            mint: publicKey(nft.mint),
        })[0];
        tx.add(await program.methods
            .updateNftPrice(contractPrice(nft.price))
            .accounts({
            userAuthority: wallet.publicKey,
            nftMint: nft.mint,
        })
            .instruction());
    }
    return await program.provider.sendAndConfirm(tx);
};
export const buyNft = async (nftMint, tokenMint) => {
    tokenMint = new web3.PublicKey(tokenMint);
    nftMint = new web3.PublicKey(nftMint);
    const isWSOL = tokenMint.toString() == Consts.wsolMint.toString();
    const buyerAuthority = wallet.publicKey;
    const globalStateKey = getGlobalStateKey();
    const globalState = await fetchGlobalState();
    const escrowAccount = await fetchEscrow(nftMint);
    const escrow = getEscrowKey(nftMint);
    const amount = isWSOL ? await getPayAmount(isWSOL, escrowAccount.price) : 0;
    isWSOL && console.log('Amount To send', amount);
    const preInstructions = isWSOL
        ? await getOrCreateWSOLATA(tokenMint, buyerAuthority, amount + 1e7)
        : [];
    const postInstructions = isWSOL
        ? [
            createCloseAccountInstruction(getAssociatedTokenAddressSync(tokenMint, buyerAuthority, true), buyerAuthority, buyerAuthority),
        ]
        : [];
    const buyerNftAccount = getAssociatedTokenAddressSync(nftMint, wallet.publicKey, true);
    const buyerTokenAccount = getAssociatedTokenAddressSync(tokenMint, buyerAuthority, true);
    const sellerTokenAccount = getAssociatedTokenAddressSync(tokenMint, escrowAccount.sellerAuthority, true);
    const feeTokenAccount = getAssociatedTokenAddressSync(tokenMint, globalStateKey, true);
    const escrowNftAccount = getAssociatedTokenAddressSync(nftMint, escrow, true);
    const tx = await program.methods
        .buyNft()
        .accounts({
        buyerAuthority,
        sellerAuthority: escrowAccount.sellerAuthority,
        nftMint,
        tokenMint,
        escrow,
        buyerNftAccount,
        buyerTokenAccount,
        sellerTokenAccount,
        feeTokenAccount,
        escrowNftAccount,
        solPriceFeed: globalState.solPriceFeed,
        solAccountRay: globalState.solAccountRay,
        caiAccountRay: globalState.caiAccountRay,
    })
        .preInstructions([MAX_COMPUE_BUDGET_IX, ...preInstructions])
        .postInstructions([...postInstructions])
        .transaction();
    const txId = await program.provider.sendAndConfirm(tx, [], TX_CONFIRM_OPTION);
    return txId;
};
export const buyMultipleNfts = async (nftMints, tokenMint) => {
    tokenMint = new web3.PublicKey(tokenMint);
    const isWSOL = tokenMint.toString() == Consts.wsolMint.toString();
    const buyerAuthority = wallet.publicKey;
    let amount = 0;
    const globalStateKey = getGlobalStateKey();
    const globalState = await fetchGlobalState();
    const feeTokenAccount = getAssociatedTokenAddressSync(tokenMint, globalStateKey, true);
    const tx = new web3.Transaction();
    const instructions = [];
    for await (const nft of nftMints) {
        const nftMint = new web3.PublicKey(nft);
        const escrowAccount = await fetchEscrow(nftMint);
        const escrow = getEscrowKey(nftMint);
        const sellerTokenAccount = getAssociatedTokenAddressSync(tokenMint, escrowAccount.sellerAuthority, true);
        const buyerNftAccount = getAssociatedTokenAddressSync(nftMint, buyerAuthority, true);
        const buyerTokenAccount = getAssociatedTokenAddressSync(tokenMint, buyerAuthority, true);
        const escrowNftAccount = getAssociatedTokenAddressSync(nftMint, escrow, true);
        amount += isWSOL ? await getPayAmount(isWSOL, escrowAccount.price) : 0;
        instructions.push(await program.methods
            .buyNft()
            .accounts({
            buyerAuthority,
            sellerAuthority: escrowAccount.sellerAuthority,
            nftMint,
            tokenMint,
            escrow,
            buyerNftAccount,
            buyerTokenAccount,
            sellerTokenAccount,
            feeTokenAccount,
            escrowNftAccount,
            solPriceFeed: globalState.solPriceFeed,
            solAccountRay: globalState.solAccountRay,
            caiAccountRay: globalState.caiAccountRay,
        })
            .instruction());
    }
    isWSOL && console.log('Amount To send', amount);
    const preInstructions = isWSOL
        ? await getOrCreateWSOLATA(tokenMint, buyerAuthority, amount + 1e7)
        : [];
    const postInstructions = isWSOL
        ? [
            await createCloseAccountInstruction(getAssociatedTokenAddressSync(tokenMint, buyerAuthority), buyerAuthority, buyerAuthority),
        ]
        : [];
    tx.add(MAX_COMPUE_BUDGET_IX);
    isWSOL && tx.add(...preInstructions);
    tx.add(...instructions);
    isWSOL && tx.add(...postInstructions);
    return await program.provider.sendAndConfirm(tx);
};
